<template>
    <div class="empty-container">
        <div class="empty-img-box" v-if="isImg">
            <img class="img-100" :src="require('@/assets/data/data_empty.png')"  alt/>
        </div>
        <div class="empty-title-box">
            {{title}}
        </div>
    </div>
</template>


<script>
export default {
    name: "dataEmpty",
    props: {
        title:{
            type: String,
            default:"暂无数据"
        },
        isImg:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {};
    },
};
</script>

<style scoped lang="scss">
.empty-container{
    width: 100%;
    height: auto;
    padding:5px;
    box-sizing: border-box;
}
.empty-img-box{
    width: 90px;
    height: 55px;
    margin: auto;
    padding-top: 20px;
    padding-bottom: 20px;
}
.empty-title-box{
    width: 120px;
    height: 20px;
    margin: auto;
    line-height: 20px;
    text-align: center;
    color: #515151;
    font-size: 14px;
}
</style>